import React from "react";
import usePWA from "react-pwa-install-prompt";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet, IonSplitPane, IonAlert, IonToast } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import Menu from "./components/Menu";

/* Pages */
import Home from "./pages/Home";
import MenuOnline from "./pages/MenuOnline";
import LocalStore from "./pages/LocalStore";
import About from "./pages/About";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./theme/utils.css";

// interface StateProps {
//   darkMode: boolean;
// }

// interface IonicAppProps extends StateProps { }

const App: React.FC = () => {
    const isServiceWorkerInitialized = useSelector((state: any) => state.serviceWorkerInitialized);
    const isServiceWorkerUpdated = useSelector((state: any) => state.serviceWorkerUpdated);
    const serviceWorkerRegistration = useSelector((state: any) => state.serviceWorkerRegistration);

    const updateServiceWorker = () => {
        const registrationWaiting = serviceWorkerRegistration.waiting;

        if (registrationWaiting) {
            registrationWaiting.postMessage({ type: "SKIP_WAITING" });

            registrationWaiting.addEventListener("statechange", (e: any) => {
                if (e.target.state === "activated") {
                    window.location.reload();
                }
            });
        }
    };

    // Stand alone check
    const { isStandalone, isInstallPromptSupported, promptInstall } = usePWA();
    const onClickInstall = async () => {
        const didInstall = await promptInstall();
        if (didInstall) {
            // User accepted PWA install
            console.log("User accepted PWA install");
        }
    };
    const renderInstallButton = () => {
        if (isInstallPromptSupported && isStandalone)
            return (
                <IonToast
                    isOpen={true}
                    message="Aggiungi Menù Online! alle tue App per averla sempre a portata di mano"
                    position="bottom"
                    translucent={true}
                    buttons={[
                        {
                            side: "start",
                            icon: "star",
                            text: "Installa",
                            handler: () => {
                              onClickInstall();
                            },
                        },
                        {
                            text: "Non ora",
                            role: "cancel",
                            handler: () => {
                                console.log("Cancel clicked");
                            },
                        },
                    ]}
                />
            );
        return null;
    };

    return (
        <IonApp>
            <div className="App-alert">
                <IonAlert
                    isOpen={isServiceWorkerInitialized}
                    header={"Menù Online!"}
                    subHeader={"Benvenuto"}
                    message={"Utilizza la nostra App per ordinare in tutta sicurezza, dal tavolo o per la consegna, direttamente a casa tua!"}
                    buttons={["OK"]}
                />
                <IonAlert
                    isOpen={isServiceWorkerUpdated}
                    header={"Menù Online!"}
                    subHeader={"Aggiornamento disponibile"}
                    message={'Fai click su "Aggiorna" per ottenere l\'ultima versione.'}
                    buttons={[
                        {
                            text: "Annulla",
                            role: "cancel",
                            cssClass: "secondary",
                            handler: () => {
                                console.log("Confirm Cancel: blah");
                            },
                        },
                        {
                            text: "Aggiorna",
                            handler: () => {
                                updateServiceWorker();
                            },
                        },
                    ]}
                />
            </div>
            <IonReactRouter>
                <IonSplitPane contentId="main">
                    <Menu />
                    <IonRouterOutlet id="main">
                        <Route path="/home" component={Home} exact={true} />
                        <Route path="/menu" component={MenuOnline} />
                        <Route path="/local" component={LocalStore} />
                        <Route path="/about" component={About} />
                        <Route exact path="/" render={() => <Redirect to="/home" />} />
                    </IonRouterOutlet>
                </IonSplitPane>
            </IonReactRouter>
            {renderInstallButton()}
        </IonApp>
    );
};

export default App;
